export default "/fcbcac1db17390110677298f9d30eeed9c121039/0c7f90dcab4574f291a5b93f31621815.svg";